import { createAsyncThunk } from "@reduxjs/toolkit";

import { requestPartPaymentWidgetApi } from "../apiRequests/requestPartPaymentWidgetApi";

export const requestPartPaymentWidget = createAsyncThunk(
  "thunks/requestPartPaymentWidget",
  async (_, thunkAPI) => {
    const { apiConfigs } = thunkAPI.getState().requests;
    const { channelId } = thunkAPI.getState().init;

    const response = await requestPartPaymentWidgetApi({
      apiConfigs,
      channelId,
    });

    return response.data;
  }
);
